import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicModalBox from "./BasicModalBox";
import BasicModalWithHeaderComp from "./BasicModalWithHeaderComp";
import DeleteWarningModalBox from "./DeleteWarningModalBox";
import WarningModalBox from "./WarningModalBox";

const ModalPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Modal"}
        description={"Menus display a list of choices on temporary surfaces."}
      />
      <Divider light />
      <BasicModalBox />
      <BasicModalWithHeaderComp />
      <DeleteWarningModalBox />
      <WarningModalBox />
    </Paper>
  );
};

export default ModalPage;
